import { render, staticRenderFns } from "./InstaTagsToolPage.vue?vue&type=template&id=047e56f1&scoped=true"
import script from "./InstaTagsToolPage.vue?vue&type=script&lang=js"
export * from "./InstaTagsToolPage.vue?vue&type=script&lang=js"
import style0 from "./InstaTagsToolPage.vue?vue&type=style&index=0&id=047e56f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047e56f1",
  null
  
)

export default component.exports